export default __webpack_public_path__ + "static/media/DS26.580b91b6.JPG";